<template>
    <div id="splashscreen" class="center-all bg-primary">
        <div class="text-center" id="splash-logo">
            <img src="@/assets/img/logo-outline-white.svg" width="120px" alt="">
            <h1  class="text-white mt-3 display-4">Greezon</h1>
        </div>
    </div>
</template>
<script setup lang="ts">
const emit = defineEmits<{
    onAnimationFinished: []
}>()
setTimeout(() => {
    emit('onAnimationFinished')
}, 3500);
</script>
<style scoped>
#splashscreen {
    position: fixed;
    width: 100%;
    height: 100%;
    bottom: 0;
    z-index: 9999;
    animation: splash-bg 0.6s 2.5s ease-in-out forwards;
}
#splash-logo {
    opacity: 0;
    transform: translateY(-70px);
    animation: splash-logo 0.7s 0.5s ease-in-out forwards;

}
@keyframes splash-bg {
    100% {
        opacity: 0;
    }
}
@keyframes splash-logo {
    0% {
        transform: translateY(-90px);
        opacity: 0;
    }
    30% {
        transform: translateY(10px);
        opacity: 1;
    }
    50% {
        transform: translateY(-20px);
        opacity: 1;
    }
    70% {
        transform: translateY(2px);
        opacity: 1;
    }
    90% {
        transform: translateY(-2px);
        opacity: 1;
    }
    100% {
        opacity: 1;
        transform: translateY(0px);
    }
}
</style>